import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.scss'],
  providers: [AngularFireAuth]
})
export class ForumComponent implements OnInit {
  user : any;
  constructor(private afAuth: AngularFireAuth) {}

  ngOnInit() {
    this.afAuth.auth.onAuthStateChanged(user => {
      this.user = user;
    })
  }

}



// WEBPACK FOOTER //
// /mnt/d/Projects/angular/chisparural-foro/src/app/forum/forum.component.ts